export enum RightMostPaneTabs {
    AskDela = 'askDela',
    TrackChanges = 'trackChanges',
    ProjectProperties = 'projectProperties',
    Keynotes = 'keynotes',
    Clashes = 'clashes',
    BestPracticeManagement = 'bestPracticeManagement',
}
